// export const ROOT_URL = document.URL.startsWith('http://localhost') ? `http://localhost:8000/` : 'http://localhost:8000/';
export const ROOT_URL = `https://manage.deltaschool.edu.vn/`;